module.exports = __webpack_public_path__ + "img/type-setting.af9d6c33.svg";